import { Box } from "ui/base/Box";
import { GridBg } from "../flow/toolbar/GridBg";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from "shad/ui/input-group";
import { ArrowRightIcon } from "lucide-react";
import { Share2Icon } from "lucide-react";
import { Link } from "react-router";
import { useMutation } from "client/useMutation";
import { Spinner } from "ui/base/Spinner";
import { newId } from "ui/lib/id";
import { useRef } from "react";
import { Field, FieldError } from "shad/ui/field";

export function LeadApp() {
  const inputRef = useRef<HTMLInputElement>(null);
  const saveLead = useMutation({ path: "leads/save" });
  return (
    <Box className="relative h-full w-full bg-transparent">
      <Box className="flex justify-center items-center flex-col size-full bg-transparent gap-6 -translate-y-1/6 p-4">
        <Link to="/">
          <Box className="flex flex-row gap-1 z-10">
            <Box className="flex flex-row items-center gap-2 grow">
              <Box className="bg-primary rounded p-1">
                <Share2Icon className="stroke-2 size-6 text-primary-foreground" />
              </Box>
              <Box className="text-primary text-2xl">sharedflow</Box>
            </Box>
            <Box className="text-xs text-muted-foreground font-light italic self-end hidden">
              beta
            </Box>
          </Box>
        </Link>{" "}
        <Box>
          <Box className="text-2xl font-light text-center text-foreground">
            Generate beautiful, animated flowcharts from plain text.
          </Box>
          <Box className="text-2xl font-light text-center text-foreground">
            Join the waitlist for early access.
          </Box>
        </Box>
        <Field className="max-w-md flex flex-col items-center justify-center">
          <InputGroup className="h-12 rounded-lg bg-white">
            <InputGroupInput
              ref={inputRef}
              size={3}
              placeholder="Enter your email address"
              className="text-lg placeholder:text-lg"
            />
            <InputGroupAddon align="inline-end">
              <InputGroupButton
                onClick={() =>
                  saveLead.mutate({
                    id: newId(),
                    email: inputRef.current?.value!,
                  })
                }
              >
                {saveLead.loading ? (
                  <Spinner className="size-5" />
                ) : (
                  <ArrowRightIcon className="size-5" />
                )}
              </InputGroupButton>
            </InputGroupAddon>
          </InputGroup>
          {saveLead.error && (
            <FieldError className="text-center">
              {saveLead.error.errors?.email}
            </FieldError>
          )}
          {saveLead.data && (
            <Box className="text-center text-green-700 text-sm">
              {saveLead.data.message}
            </Box>
          )}
        </Field>
      </Box>
      <GridBg />
    </Box>
  );
}
